export default __webpack_public_path__ + "static/media/mustang.4731db89.png";